import { render, staticRenderFns } from "./TruewalletGift.vue?vue&type=template&id=34813584&scoped=true&"
import script from "./TruewalletGift.vue?vue&type=script&lang=js&"
export * from "./TruewalletGift.vue?vue&type=script&lang=js&"
import style0 from "./TruewalletGift.vue?vue&type=style&index=0&id=34813584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34813584",
  null
  
)

export default component.exports